module.exports={
  "Close": "Luk",
  "Choose how to share": "VÃ¦lg, hvordan du deler",
  "Share": "Del",
  "Download": "Hent",
  "Check this out: %s": "Se her: %s",
  "Copied!": "Kopieret!",
  "Copy link": "Kopier link"
}
